/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_Format_LabelInputs */

const en_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto format event text`)
};

const fr_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en forme automatiquement le texte des événements`)
};

const de_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung des Ereignistextes`)
};

const it_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione automatica del testo dell'evento`)
};

const ru_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование текста события`)
};

const es_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatear automáticamente el texto del evento`)
};

const zh_cn2_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化事件文本`)
};

const ja_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストの自動フォーマット`)
};

const hi_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट को स्वचालित रूप से फ़ॉर्मेट करें`)
};

const pt_pt2_context_menu_auto_format_label = /** @type {(inputs: Context_Menu_Auto_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática do texto do evento`)
};

/**
* | output |
* | --- |
* | "Auto format event text" |
*
* @param {Context_Menu_Auto_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_format_label = /** @type {((inputs?: Context_Menu_Auto_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_auto_format_label(inputs)
	if (locale === "de") return de_context_menu_auto_format_label(inputs)
	if (locale === "it") return it_context_menu_auto_format_label(inputs)
	if (locale === "ru") return ru_context_menu_auto_format_label(inputs)
	if (locale === "es") return es_context_menu_auto_format_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_auto_format_label(inputs)
	if (locale === "ja") return ja_context_menu_auto_format_label(inputs)
	if (locale === "hi") return hi_context_menu_auto_format_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_auto_format_label(inputs)
	return en_context_menu_auto_format_label(inputs)
});